import React, { useState, useEffect } from 'react';
import recommendationMealsAPI from '../services/recommendationMealsAPI';

function RecommendedMeals() {
  const [recommendationMeals, setRecommendationMeals] = useState([]);

  useEffect(() => {
    const fetchRecommendedMeals = async () => {
      const getRecommendedMeals = await recommendationMealsAPI();
      setRecommendationMeals(getRecommendedMeals);
    };
    fetchRecommendedMeals();
  }, []);

  const maxMeals = 6;
  const initialMeals = 0;
  const sixMeal = recommendationMeals.slice(initialMeals, maxMeals);

  return (
    <div className="recommend">
      <h2>Recommended</h2>
      <ul className="cardsRecommendedCarousel">
        {sixMeal.map((recommendationMeal, index) => (
          <li
            className="cardRecommendedCarousel"
            data-testid={ `${index}-recomendation-card` }
            key={ index }
          >
            <img
              src={ recommendationMeal.strMealThumb }
              alt={ recommendationMeal.strMeal }
              width="175px"
            />
            <h3
              data-testid={ `${index}-recomendation-title` }
            >
              { recommendationMeal.strMeal }
            </h3>
            <p>{ recommendationMeal.strCategory }</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default RecommendedMeals;
